import { candidateRequests } from "api/candidateApi";
import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { CampaignSubTypes } from "utils/constants";

const RegularCampaignCandidates = ({ handleParamChange }) => {
  return (
    <>
      <ReferenceInput
        label="Кампания"
        source="campaignId"
        reference={candidateRequests.getCampaignsSelect()}
        filter={{ subType: CampaignSubTypes.Regular }}
      >
        <SelectInput
          validate={required()}
          label="Кампания"
          optionText="nameBg"
          onChange={e => handleParamChange("campaignId", e.target.value)}
        />
      </ReferenceInput>
    </>
  );
};

export default RegularCampaignCandidates;
